import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiConfig';

const ClientDetails = () => {
  const countries = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola",
    "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
    "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus",
    "Belgium", "Belize", "Benin", "Bhutan", "Bolivia",
    "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
    "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon",
    "Canada", "Central African Republic", "Chad", "Chile", "China",
    "Colombia", "Comoros", "Congo (Brazzaville)", "Congo (Kinshasa)", "Costa Rica",
    "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark",
    "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt",
    "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini",
    "Ethiopia", "Fiji", "Finland", "France", "Gabon",
    "Gambia", "Georgia", "Germany", "Ghana", "Greece",
    "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
    "Haiti", "Honduras", "Hungary", "Iceland", "India",
    "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
    "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan",
    "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos",
    "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
    "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi",
    "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands",
    "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova",
    "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique",
    "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
    "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea",
    "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
    "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines",
    "Poland", "Portugal", "Qatar", "Romania", "Russia",
    "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa",
    "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia",
    "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
    "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan",
    "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden",
    "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",
    "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago",
    "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda",
    "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay",
    "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
    "Yemen", "Zambia", "Zimbabwe"
  ];

  const navigate = useNavigate();
  const { userId: paramUserId } = useParams();

  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    try {
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const [authReady, setAuthReady] = useState(false);

  // Derived IDs
  const numericUserId = user?.userId ?? null;

  const [smartSizes, setSmartSizes] = useState([]);
  const [bodyMeasurements, setBodyMeasurements] = useState([]);
  const [selectedBodyMeasurement, setSelectedBodyMeasurement] = useState(null);
  const [showBodyPopup, setShowBodyPopup] = useState(false);
  const [isEditingAddress, setIsEditingAddress] = useState(false);

  const [measurementVideos, setMeasurementVideos] = useState({ Body: {}, Shirt: {} });
  const [currentVideoKey, setCurrentVideoKey] = useState(null);
  const [currentVideoType, setCurrentVideoType] = useState('Body');

  const [bodyForm, setBodyForm] = useState({
    neckAround: '',
    sleeveLength: '',
    shoulderWidth: '',
    chestAround: '',
    waistAround: '',
    shirtLength: '',
    bicepAround: '',
    wristAround: '',
    fit: 'Regular',
  });

  const [shirtMeasurements, setShirtMeasurements] = useState([]);
  const [showShirtPopup, setShowShirtPopup] = useState(false);
  const [selectedShirtMeasurement, setSelectedShirtMeasurement] = useState(null);
  const [shirtForm, setShirtForm] = useState({
    collarAround: '',
    sleeveLength: '',
    yokeWidth: '',
    chestWidth: '',
    midsectionWidth: '',
    shirtLength: '',
    sleeveWidth: '',
    cuffAround: ''
  });

  // ---------- STANDARD SIZES ----------

// OPTIONS must be declared BEFORE any useState default that depends on them
const COLLAR_OPTIONS = [
  { value: '14.5', label: 'XS' },
  { value: '15', label: 'S' },
  { value: '15.5', label: 'M' },
  { value: '16', label: 'M/L' },
  { value: '16.5', label: 'L' },
  { value: '17', label: 'XL' },
  { value: '17.5', label: 'XL' },
  { value: '18', label: '2XL' },
  { value: '18.5', label: '2XL' },
  { value: '19', label: '3XL' },
  { value: '20', label: '4XL' },
  { value: '21', label: '5XL' }
];

const SLEEVE_OPTIONS_SMALL_COLLAR = [
  { value: '32', label: `5'6"–5'8"` },
  { value: '33', label: `5'8"–5'9"` },
  { value: '34', label: `5'10"–5'11"` },
  { value: '35', label: `6'0"–6'1"` },
];

const SLEEVE_OPTIONS_LARGE_COLLAR = [
  { value: '33', label: `5'8"–5'9"` },
  { value: '34', label: `5'10"–5'11"` },
  { value: '35', label: `6'0"–6'1"` },
  { value: '36', label: `6'2"–6'3"` },
];

const FIT_OPTIONS = [
  { value: 'Slim', label: 'Slim' },
  { value: 'Classic', label: 'Classic' },
  { value: 'Athletic', label: 'Athletic' }
];

// Use function declaration (hoisted) and keep it ABOVE useState
function getDefaultStandardSize() {
  const defaultCollar = COLLAR_OPTIONS[0]?.value || '';
  const collarNum = parseFloat(defaultCollar);

  const sleeveList =
    collarNum && collarNum <= 15
      ? SLEEVE_OPTIONS_SMALL_COLLAR
      : SLEEVE_OPTIONS_LARGE_COLLAR;

  return {
    collarSize: defaultCollar,
    sleeveLength: sleeveList[0]?.value || '',
    fit: FIT_OPTIONS[0]?.value || ''
  };
}

const [standardSize, setStandardSize] = useState(getDefaultStandardSize);
const [standardSizeList, setStandardSizeList] = useState([]);
const [standardSizeSaved, setStandardSizeSaved] = useState(null);


  const sleeveOptionsForCurrentCollar = React.useMemo(() => {
    const collar = parseFloat(standardSize.collarSize);
    if (!collar) {
      // default view – same as 15.5+ in your screenshots
      return SLEEVE_OPTIONS_LARGE_COLLAR;
    }

    // 14.5 or 15 → shorter sleeve set
    if (collar <= 15) {
      return SLEEVE_OPTIONS_SMALL_COLLAR;
    }

    // 15.5 and above → longer sleeve set
    return SLEEVE_OPTIONS_LARGE_COLLAR;
  }, [standardSize.collarSize]);

  useEffect(() => {
  const firstSleeve = sleeveOptionsForCurrentCollar?.[0]?.value || '';

  // If sleeve not picked yet, pick the first one automatically
  if (!standardSize.sleeveLength && firstSleeve) {
    setStandardSize(prev => ({ ...prev, sleeveLength: firstSleeve }));
    return;
  }

  // If sleeve picked but no longer valid (collar changed), snap to first valid
  const stillValid = sleeveOptionsForCurrentCollar.some(
    opt => opt.value === standardSize.sleeveLength
  );

  if (!stillValid && firstSleeve) {
    setStandardSize(prev => ({ ...prev, sleeveLength: firstSleeve }));
  }
}, [sleeveOptionsForCurrentCollar, standardSize.sleeveLength]);

  // ----------------------------------------------------------

  // Frontend auth guard
  useEffect(() => {
    if (!user) {
      setAuthReady(true);
      navigate('/login', { replace: true });
      return;
    }

    const isAdmin =
      user?.roles?.includes('SuperAdmin') ||
      user?.roles?.includes('Admin') ||
      user?.isAdmin;

    if (!isAdmin && numericUserId && paramUserId && String(numericUserId) !== String(paramUserId)) {
      setAuthReady(true);
      navigate(`/ClientDetails/${numericUserId}`, { replace: true });
      return;
    }

    setAuthReady(true);
  }, [user, numericUserId, paramUserId, navigate]);

  console.log("🔍 Loaded user from localStorage:", user);

  const handleEditSmartSize = (smartSize) => {
    if (!numericUserId) return;
    localStorage.setItem('editSmartSize', JSON.stringify(smartSize));
    navigate(`/smartSizes/edit/${numericUserId}`);
  };

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [billingInfo, setBillingInfo] = useState({
    phoneNumber: user?.phoneNumber || '',
    address: user?.address || '',
    city: user?.city || '',
    state: user?.state || '',
    postalCode: user?.postalCode || '',
    country: user?.country || '',
  });

  const handleBillingChange = (e) => {
    const { name, value } = e.target;
    setBillingInfo(prev => ({ ...prev, [name]: value }));
  };

  const handleBillingSave = async () => {
    try {
      const payload = {
        userId: numericUserId,
        ...billingInfo
      };

      const token = localStorage.getItem('token');

      const res = await fetch(`${API_BASE_URL}/UserManagement/UpdateBillingInfo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const err = await res.json();
        alert(err.message || 'Failed to update billing info');
        return;
      }

      const updatedUser = await res.json();
      const mergedUser = { ...user, ...updatedUser };
      localStorage.setItem('user', JSON.stringify(mergedUser));
      setUser(mergedUser);
    } catch (err) {
      console.error('❌ Billing update failed:', err);
      alert('Something went wrong');
    }
  };

  // measurement videos (public)
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/measurement-videos`)
      .then(res => res.json())
      .then(data => setMeasurementVideos(data))
      .catch(err => console.error("Error loading measurement videos:", err));
  }, []);

  // Keep user in sync if another tab logs in/out
  useEffect(() => {
    const checkUser = () => {
      const stored = localStorage.getItem('user');
      try {
        setUser(stored ? JSON.parse(stored) : null);
      } catch {
        setUser(null);
      }
    };
    window.addEventListener('storage', checkUser);
    return () => window.removeEventListener('storage', checkUser);
  }, []);

  // Populate form from user
  useEffect(() => {
    if (user) {
      setFormData({
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        username: user.username || '',
        email: user.email || '',
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });

      setBillingInfo({
        phoneNumber: user?.phoneNumber || '',
        address: user?.address || '',
        city: user?.city || '',
        state: user?.state || '',
        postalCode: user?.postalCode || '',
        country: user?.country || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (formData.newPassword && formData.newPassword !== formData.confirmPassword) {
      alert("New password and confirm password do not match");
      return;
    }

    try {
      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/UserManagement/UpdateAccountDetails`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify({
          userId: numericUserId,
          firstName: formData.firstName,
          lastName: formData.lastName,
          username: formData.username,
          email: formData.email,
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword
        })
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.message || "Update failed");
        return;
      }

      localStorage.setItem('user', JSON.stringify(data));
      setUser(data);
      alert("Profile updated successfully");

      setFormData(prev => ({
        ...prev,
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }));
    } catch (err) {
      console.error("Update error", err);
      alert("Something went wrong");
    }
  };

  // Smart Sizes
    // Load saved Standard Sizes
  useEffect(() => {
    if (!numericUserId) return;

    const token = localStorage.getItem('token');

    fetch(`${API_BASE_URL}/UserManagement/GetStandardSizes/${numericUserId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
      .then(res => (res.ok ? res.json() : null))
      .then(data => {
        if (!data) {
          // nothing saved
          setStandardSizeList([]);
          setStandardSize(getDefaultStandardSize());
setStandardSizeSaved(null);
          return;
        }

        // normalise to array
        const list = Array.isArray(data) ? data : [data];
        setStandardSizeList(list);

        // Use first record as "current"
        const record = list[0];

        if (!record || !record.standardSizeId) {
          setStandardSize(getDefaultStandardSize());
setStandardSizeSaved(null);
          return;
        }

        setStandardSizeSaved(record);
        const normalize = (v) => (v === null || v === undefined ? '' : String(v).trim());

        setStandardSize({
          collarSize: normalize(record.collarSize),
          sleeveLength: normalize(record.sleeveLength),
          fit: normalize(record.fit),
        });
      })
      .catch(err => {
        console.error('Error loading standard size:', err);
        setStandardSizeList([]);
        setStandardSize(getDefaultStandardSize());
setStandardSizeSaved(null);
      });
  }, [numericUserId]);



  // Body measurements
  useEffect(() => {
    if (!numericUserId) return;

    const token = localStorage.getItem('token');

    fetch(`${API_BASE_URL}/UserManagement/GetBodyMeasurements/${numericUserId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
      .then(res => res.ok ? res.json() : [])
      .then(data => setBodyMeasurements(Array.isArray(data) ? data : []))
      .catch(err => console.error("Error loading body measurements:", err));
  }, [numericUserId]);

  const handleDeleteBodyMeasurement = async (id) => {
    if (!window.confirm("Are you sure you want to delete this measurement?")) return;

    const token = localStorage.getItem('token');

    await fetch(`${API_BASE_URL}/UserManagement/DeleteBodyMeasurement/${id}`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });

    setBodyMeasurements(prev => prev.filter(m => m.bodyMeasurementId !== id));
  };

  const handleBodyInputChange = (key, value) => {
    setBodyForm(prev => ({ ...prev, [key]: value }));
  };

  const [fitDropdownOpen, setFitDropdownOpen] = useState(false);

  const handleFitSelect = (value) => {
    setBodyForm(prev => ({ ...prev, fit: value }));
    setFitDropdownOpen(false);
  };

  const handleSaveBodyMeasurement = async () => {
  if (!numericUserId) return;

  const payload = {
    ...bodyForm,
    userId: numericUserId,
    // ✅ send ID when editing, 0 when creating
    bodyMeasurementId: selectedBodyMeasurement?.bodyMeasurementId || 0,
  };

  // ✅ choose correct endpoint
  const url = selectedBodyMeasurement
    ? `${API_BASE_URL}/UserManagement/UpdateBodyMeasurement`
    : `${API_BASE_URL}/UserManagement/AddBodyMeasurement`;

  const token = localStorage.getItem('token');

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify(payload),
  });

  if (res.ok) {
    const saved = await res.json();

    if (selectedBodyMeasurement) {
      // ✅ update existing row in state
      setBodyMeasurements(prev =>
        prev.map(m =>
          m.bodyMeasurementId === saved.bodyMeasurementId ? saved : m
        )
      );
    } else {
      // ✅ append new one
      setBodyMeasurements(prev => [...prev, saved]);
    }

    setShowBodyPopup(false);
    setSelectedBodyMeasurement(null); // ✅ clear edit selection

    // reset form
    setBodyForm({
      neckAround: '',
      sleeveLength: '',
      shoulderWidth: '',
      chestAround: '',
      waistAround: '',
      shirtLength: '',
      bicepAround: '',
      wristAround: '',
      fit: 'Regular',
    });
  } else {
    alert('Failed to save measurement');
  }
};


  useEffect(() => {
    if (selectedBodyMeasurement) {
      setBodyForm({
        neckAround: selectedBodyMeasurement.neckAround || '',
        sleeveLength: selectedBodyMeasurement.sleeveLength || '',
        shoulderWidth: selectedBodyMeasurement.shoulderWidth || '',
        chestAround: selectedBodyMeasurement.chestAround || '',
        waistAround: selectedBodyMeasurement.waistAround || '',
        shirtLength: selectedBodyMeasurement.shirtLength || '',
        bicepAround: selectedBodyMeasurement.bicepAround || '',
        wristAround: selectedBodyMeasurement.wristAround || '',
        fit: selectedBodyMeasurement.fit || 'Regular',
      });
    } else {
      setBodyForm({
        neckAround: '',
        sleeveLength: '',
        shoulderWidth: '',
        chestAround: '',
        waistAround: '',
        shirtLength: '',
        bicepAround: '',
        wristAround: '',
        fit: 'Regular',
      });
    }
  }, [selectedBodyMeasurement]);

  // Shirt measurements
  useEffect(() => {
    if (!numericUserId) return;

    const token = localStorage.getItem('token');

    fetch(`${API_BASE_URL}/UserManagement/GetShirtMeasurements/${numericUserId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
      .then(res => res.ok ? res.json() : [])
      .then(data => setShirtMeasurements(Array.isArray(data) ? data : []))
      .catch(err => console.error("Error loading shirt measurements:", err));
  }, [numericUserId]);

  const handleShirtInputChange = (key, value) => {
    setShirtForm(prev => ({ ...prev, [key]: value }));
  };

  const handleSaveShirtMeasurement = async () => {
    if (!numericUserId) return;

    const payload = {
      ...shirtForm,
      userId: numericUserId,
      shirtMeasurementId: selectedShirtMeasurement?.shirtMeasurementId || 0
    };

    const url = selectedShirtMeasurement
      ? `${API_BASE_URL}/UserManagement/UpdateShirtMeasurement`
      : `${API_BASE_URL}/UserManagement/AddShirtMeasurement`;

    const token = localStorage.getItem('token');

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify(payload)
    });

    if (res.ok) {
      const saved = await res.json();

      if (selectedShirtMeasurement) {
        setShirtMeasurements(prev =>
          prev.map(m => m.shirtMeasurementId === saved.shirtMeasurementId ? saved : m)
        );
      } else {
        setShirtMeasurements(prev => [...prev, saved]);
      }

      setShowShirtPopup(false);
      setSelectedShirtMeasurement(null);
      setShirtForm({
        collarAround: '',
        sleeveLength: '',
        yokeWidth: '',
        chestWidth: '',
        midsectionWidth: '',
        shirtLength: '',
        sleeveWidth: '',
        cuffAround: ''
      });
    } else {
      alert('Failed to save measurement');
    }
  };

  const handleDeleteShirtMeasurement = async (id) => {
    if (!window.confirm("Are you sure you want to delete this measurement?")) return;

    const token = localStorage.getItem('token');

    await fetch(`${API_BASE_URL}/UserManagement/DeleteShirtMeasurement/${id}`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });

    setShirtMeasurements(prev => prev.filter(m => m.shirtMeasurementId !== id));
  };

  const handleStandardSelect = (key, value) => {
    setStandardSize(prev => ({ ...prev, [key]: value }));
  };

    const handleEditStandardSize = (record) => {
  if (!record) return;

  const normalize = (v) => (v === null || v === undefined ? '' : String(v).trim());

  setStandardSize({
    collarSize: normalize(record.collarSize),
    sleeveLength: normalize(record.sleeveLength),
    fit: normalize(record.fit),
  });

  setStandardSizeSaved(record);
};



    const handleSaveStandardSize = async () => {
  if (!numericUserId) return;

  if (!standardSize.collarSize || !standardSize.sleeveLength || !standardSize.fit) {
    alert('Please select Collar Size, Sleeve Length and Fit.');
    return;
  }

  const payload = {
    userId: numericUserId,
    collarSize: standardSize.collarSize,
    sleeveLength: standardSize.sleeveLength,
    fit: standardSize.fit,
    standardSizeSelectionId: standardSizeSaved?.standardSizeSelectionId || 0
  };

  const url = standardSizeSaved
    ? `${API_BASE_URL}/UserManagement/UpdateStandardSize`
    : `${API_BASE_URL}/UserManagement/AddStandardSize`;

  const token = localStorage.getItem('token');

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify(payload)
  });

  if (!res.ok) {
    alert('Failed to save standard size');
    return;
  }

  const saved = await res.json();

  // update/merge into list
  setStandardSizeList(prev => {
    if (!prev || prev.length === 0) return [saved];
    const exists = prev.some(s => s.standardSizeSelectionId === saved.standardSizeSelectionId);
    return exists
      ? prev.map(s => (s.standardSizeSelectionId === saved.standardSizeSelectionId ? saved : s))
      : [...prev, saved];
  });

  // clear current selection + form
  setStandardSizeSaved(null);
  setStandardSize({
    collarSize: '',
    sleeveLength: '',
    fit: ''
  });

  alert('Standard size saved.');
};




  if (!authReady) {
    return null;
  }

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">
        {/* Breadcrumb */}
        <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb-inner text-center">
                  <h2 className="title">My Account</h2>
                  <ul className="page-list">
                    <li className="rbt-breadcrumb-item"><a href="/">Home</a></li>
                    <li><div className="icon-right"><i className="feather-chevron-right"></i></div></li>
                    <li className="rbt-breadcrumb-item active">My Account</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Account Section */}
        <div className="my-account-section bg-color-white rbt-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="row g-5">
                  {/* Sidebar */}
                  <div className="col-lg-3 col-12">
                    <div className="rbt-my-account-tab-button nav" role="tablist">
                      <a href="#standard-sizes" className="active" data-bs-toggle="tab">Standard Sizes</a>
                      <a href="#download" data-bs-toggle="tab">Smart Sizes</a>
                      <a href="#body-measurement" data-bs-toggle="tab">Measure Your Body</a>
                      <a href="#shirt-measurement" data-bs-toggle="tab">Measure a Shirt</a>
                      <a href="#fitadvice" data-bs-toggle="tab">Fit Advice Requests</a>
                      <a href="#returns" data-bs-toggle="tab">Returns</a>
                      <a href="#address-edit" data-bs-toggle="tab">Address</a>
                      <a href="#account-info" data-bs-toggle="tab">Account Details</a>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          localStorage.removeItem('user');
                          localStorage.removeItem('token');
                          localStorage.removeItem('username');
                          setUser(null);
                          console.log("🚪 Logging out: user cleared, redirecting...");
                          window.location.href = '/';
                        }}
                      >
                        <i className="feather-log-out"></i><span>Logout</span>
                      </a>
                    </div>
                  </div>

                  {/* Tab Content */}
                  <div className="col-lg-9 col-12">
                    <div className="tab-content" id="myaccountContent">

                      {/* STANDARD SIZES */}
                      <div className="tab-pane fade active show" id="standard-sizes" role="tabpanel">
                        <div className="rbt-my-account-inner">
                          <h3 className="mb--20">Standard Sizes</h3>

                          <div
                            className="standard-size-card"
                            style={{
                              border: '1px solid #e0e0e0',
                              borderRadius: '12px',
                              padding: '24px',
                              maxWidth: '640px',
                              boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}
                          >
                            <div
                              className="standard-size-header"
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '24px'
                              }}
                            >
                              <div style={{ display: 'flex', gap: '24px', fontSize: '0.85rem', letterSpacing: '0.08em' }}>
                                <span style={{ fontWeight: 600, borderBottom: '2px solid #000', paddingBottom: '4px' }}>
                                  STANDARD SIZES
                                </span>
                                {/* <span style={{ color: '#888' }}>CUSTOM SIZES</span> */}
                              </div>
                              {/* <button
                                type="button"
                                style={{
                                  border: 'none',
                                  background: 'none',
                                  textDecoration: 'underline',
                                  fontSize: '0.85rem',
                                  cursor: 'pointer'
                                }}
                              >
                                Find Your Size
                              </button> */}
                            </div>

                            {/* Collar */}
                            <div style={{ marginBottom: '24px' }}>
                              <div style={{ fontSize: '0.78rem', letterSpacing: '0.12em', fontWeight: 600, marginBottom: '12px' }}>
                                COLLAR SIZE
                              </div>
                              <div
                                className="std-grid"
                                style={{
                                  display: 'grid',
                                  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                                  gap: '12px'
                                }}
                              >
                                {COLLAR_OPTIONS.map(opt => {
                                  const active = standardSize.collarSize === opt.value;
                                  return (
                                    <button
                                      key={opt.value}
                                      type="button"
                                      onClick={() => handleStandardSelect('collarSize', opt.value)}
                                      style={{
                                        borderRadius: '6px',
                                        border: active ? '2px solid #000' : '1px solid #d0d0d0',
                                        backgroundColor: active ? '#3d4048' : '#fff',
                                        color: active ? '#fff' : '#111',
                                        padding: '10px 8px',
                                        fontSize: '0.95rem',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: active ? '0 0 0 3px rgba(0,0,0,0.15)' : 'none',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      <span>{opt.value}</span>
                                      <span style={{ fontSize: '0.7rem', color: active ? '#e0e0e0' : '#888', marginTop: '4px' }}>
                                        {opt.label}
                                      </span>
                                    </button>
                                  );
                                })}
                              </div>
                            </div>

                            {/* Sleeve */}
                            <div style={{ marginBottom: '24px' }}>
                              <div style={{ fontSize: '0.78rem', letterSpacing: '0.12em', fontWeight: 600, marginBottom: '12px' }}>
                                SLEEVE LENGTH
                              </div>
                              <div
                                style={{
                                  display: 'grid',
                                  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                                  gap: '12px'
                                }}
                              >
                                {sleeveOptionsForCurrentCollar.map(opt => {
                                  const active = standardSize.sleeveLength === opt.value;
                                  return (
                                    <button
                                      key={opt.value}
                                      type="button"
                                      onClick={() => handleStandardSelect('sleeveLength', opt.value)}
                                      style={{
                                        borderRadius: '6px',
                                        border: active ? '2px solid #000' : '1px solid #d0d0d0',
                                        backgroundColor: active ? '#3d4048' : '#fff',
                                        color: active ? '#fff' : '#111',
                                        padding: '10px 8px',
                                        fontSize: '0.95rem',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: active ? '0 0 0 3px rgba(0,0,0,0.15)' : 'none',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      <span>{opt.value}</span>
                                      <span style={{ fontSize: '0.7rem', color: active ? '#e0e0e0' : '#888', marginTop: '4px' }}>
                                        {opt.label}
                                      </span>
                                    </button>
                                  );
                                })}
                              </div>
                            </div>

                            {/* Fit */}
                            <div style={{ marginBottom: '24px' }}>
                              <div style={{ fontSize: '0.78rem', letterSpacing: '0.12em', fontWeight: 600, marginBottom: '12px' }}>
                                FIT
                              </div>
                              <div
                                style={{
                                  display: 'grid',
                                  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                                  gap: '12px'
                                }}
                              >
                                {FIT_OPTIONS.map(opt => {
                                  const active = standardSize.fit === opt.value;
                                  return (
                                    <button
                                      key={opt.value}
                                      type="button"
                                      onClick={() => handleStandardSelect('fit', opt.value)}
                                      style={{
                                        borderRadius: '6px',
                                        border: active ? '2px solid #000' : '1px solid #d0d0d0',
                                        backgroundColor: active ? '#3d4048' : '#fff',
                                        color: active ? '#fff' : '#111',
                                        padding: '10px 8px',
                                        fontSize: '0.9rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: active ? '0 0 0 3px rgba(0,0,0,0.15)' : 'none',
                                        cursor: 'pointer',
                                        position: 'relative'
                                      }}
                                    >
                                      {opt.label}
                                      {opt.value === 'Slim' && (
                                        <span
                                          style={{
                                            position: 'absolute',
                                            bottom: '-16px',
                                            fontSize: '0.7rem',
                                            color: '#888'
                                          }}
                                        >
                                          Most Popular
                                        </span>
                                      )}
                                    </button>
                                  );
                                })}
                              </div>
                            </div>

                            <button
                              type="button"
                              className="rbt-btn btn-gradient"
                              onClick={handleSaveStandardSize}
                            >
                              Save Standard Size
                            </button>
                          </div>

                          {/* Saved Standard Sizes table */}
                          {standardSizeList.length > 0 && (
                            <div className="rbt-my-account-table table-responsive text-center mt--30">
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>Collar</th>
                                    <th>Sleeve</th>
                                    <th>Fit</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {standardSizeList.map(ss => (
                                    <tr key={ss.standardSizeSelectionId}>
                                      <td>{ss.collarSize || '-'}</td>
                                      <td>{ss.sleeveLength || '-'}</td>
                                      <td>{ss.fit || '-'}</td>
                                      <td>
                                        <button
                                          className="rbt-btn btn-gradient btn-sm"
                                          onClick={() => handleEditStandardSize(ss)}
                                        >
                                          Edit
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Smart Sizes */}
                      <div className="tab-pane fade" id="download" role="tabpanel">
                        {!Array.isArray(smartSizes) || smartSizes.length === 0 ? (
                          <div id="smart-size-empty-state" style={{
                            padding: '3rem 2rem',
                            border: '1px solid #e0e0e0',
                            borderRadius: '12px',
                            backgroundColor: '#fafafa',
                            maxWidth: '900px',
                            margin: '0 auto',
                            boxShadow: '0 0 10px rgba(0,0,0,0.03)'
                          }}>
                            <h2 style={{
                              fontSize: '2rem',
                              fontWeight: '700',
                              marginBottom: '1.5rem',
                              color: '#1d1d1f'
                            }}>
                              Create a Size
                            </h2>

                            <div style={{
                              padding: '2rem',
                              backgroundColor: '#fff',
                              borderRadius: '10px',
                              border: '1px solid #ddd',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                                <h3 style={{
                                  fontSize: '1.25rem',
                                  fontWeight: '600',
                                  color: '#333',
                                  marginRight: '1rem',
                                  marginBottom: 0
                                }}>
                                  Smart Sizes
                                </h3>
                                <span style={{
                                  backgroundColor: '#e0e0e0',
                                  color: '#333',
                                  fontSize: '0.75rem',
                                  padding: '0.2rem 0.6rem',
                                  borderRadius: '999px'
                                }}>
                                  Most Popular
                                </span>
                              </div>

                              <p style={{
                                fontSize: '1rem',
                                color: '#555',
                                marginBottom: '1.5rem',
                                lineHeight: '1.6'
                              }}>
                                Answer a few simple questions about your body and let our algorithms calculate your ideal custom size. Smart Sizes is based on millions of customer data points and is incredibly accurate.
                              </p>

                              <a
                                href={numericUserId ? `/smartSizes/new/${numericUserId}` : '#'}
                                style={{
                                  display: 'inline-block',
                                  backgroundColor: '#000',
                                  color: '#fff',
                                  padding: '0.75rem 1.5rem',
                                  borderRadius: '6px',
                                  textDecoration: 'none',
                                  fontWeight: '600',
                                  fontSize: '0.9rem',
                                  transition: 'background-color 0.2s'
                                }}
                                onMouseOver={e => e.currentTarget.style.backgroundColor = '#222'}
                                onMouseOut={e => e.currentTarget.style.backgroundColor = '#000'}
                              >
                                USE SMART SIZES
                              </a>
                            </div>
                          </div>
                        ) : (
                          <div className="rbt-smart-sizes-section">
                            <div className="rbt-smart-sizes-header">
                              <h3>Saved Shirt Sizes</h3>
                              <div className="rbt-smart-sizes-tabs">
                                <button className="rbt-tab active">Shirts</button>
                              </div>
                              <a
                                href={numericUserId ? `/smartSizes/new/${numericUserId}` : '#'}
                                className="rbt-new-size-btn"
                              >
                                + Create a New Size
                              </a>
                            </div>

                            <div className="rbt-smart-sizes-list" id="rbt-tab-content">
                              {smartSizes.map((size, i) => (
                                <div className="rbt-size-item" key={size.smartSizeId}>
                                  <input type="checkbox" className="rbt-checkbox" />
                                  <div className="rbt-size-info">
                                    <strong>Smart Sizes – {size.name || `Size ${i + 1}`}</strong>
                                  </div>
                                  <button className="rbt-edit-btn" onClick={() => handleEditSmartSize(size)}>
                                    View / Edit
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Measure Your Body */}
                      <div className="tab-pane fade" id="body-measurement" role="tabpanel">
                        <div className="rbt-my-account-inner">
                          <h3 className="mb--10">Measure Your Body</h3>

                          <p style={{ marginTop: '10px', color: '#555' }}>
                            Provide your actual body measurements to ensure a perfect tailored fit. Our expert tailors will use these measurements to craft a shirt that's designed to match your body shape precisely.
                          </p>

                          <button
                            className="rbt-btn btn-gradient mt--20"
                            onClick={() => {
                              setSelectedBodyMeasurement(null);
                              setShowBodyPopup(true);
                            }}
                          >
                            + Add Measurement
                          </button>

                          <div className="rbt-my-account-table table-responsive text-center mt--30">
                            {bodyMeasurements.length === 0 ? (
                              <div style={{
                                padding: '2rem',
                                border: '1px solid #e0e0e0',
                                borderRadius: '12px',
                                backgroundColor: '#f9f9f9',
                                maxWidth: '100%',
                                width: '100%',
                                boxSizing: 'border-box',
                                textAlign: 'center'
                              }}>
                                <h4 style={{
                                  fontWeight: '600',
                                  fontSize: '1.5rem',
                                  marginBottom: '1rem',
                                  color: '#333'
                                }}>
                                  No Body Measurements Saved
                                </h4>

                                <p style={{
                                  maxWidth: '100%',
                                  wordWrap: 'break-word',
                                  whiteSpace: 'normal',
                                  lineHeight: '1.6',
                                  color: '#777'
                                }}>
                                  To ensure your shirts fit perfectly, please add your body measurements. You can measure key areas like neck, sleeve length, chest, and waist, or follow our simple guide in the pop-up.
                                </p>
                              </div>
                            ) : (
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>Neck</th>
                                    <th>Sleeve</th>
                                    <th>Chest</th>
                                    <th>Waist</th>
                                    <th>Fit</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {bodyMeasurements.map(measure => (
                                    <tr key={measure.bodyMeasurementId}>
                                      <td>{measure.neckAround || '-'}</td>
                                      <td>{measure.sleeveLength || '-'}</td>
                                      <td>{measure.chestAround || '-'}</td>
                                      <td>{measure.waistAround || '-'}</td>
                                      <td>{measure.fit || '-'}</td>
                                      <td>
                                        <button
                                          onClick={() => {
                                            setSelectedBodyMeasurement(measure);
                                            setShowBodyPopup(true);
                                          }}
                                          className="rbt-btn btn-gradient btn-sm"
                                        >
                                          Edit
                                        </button>
                                        <button
                                          onClick={() => handleDeleteBodyMeasurement(measure.bodyMeasurementId)}
                                          className="rbt-btn btn-danger btn-gradient btn-sm ms--10"
                                        >
                                          Delete
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Measure Your Shirt */}
                      <div className="tab-pane fade" id="shirt-measurement" role="tabpanel">
                        <div className="rbt-my-account-inner">
                          <h3 className="mb--10">Measure Your Shirt</h3>

                          <p style={{ marginTop: '10px', color: '#555' }}>
                            Add measurements from your favorite well-fitting shirt to help us create a perfect replica tailored to your preferences.
                          </p>

                          <button
                            className="rbt-btn btn-gradient mt--20"
                            onClick={() => {
                              setSelectedShirtMeasurement(null);
                              setShirtForm({
                                collarAround: '',
                                sleeveLength: '',
                                yokeWidth: '',
                                chestWidth: '',
                                midsectionWidth: '',
                                shirtLength: '',
                                sleeveWidth: '',
                                cuffAround: ''
                              });
                              setShowShirtPopup(true);
                            }}
                          >
                            + Add Shirt Measurement
                          </button>

                          <div className="rbt-my-account-table table-responsive text-center mt--30">
                            {shirtMeasurements.length === 0 ? (
                              <div style={{ padding: '2rem', border: '1px solid #ddd', borderRadius: '12px', backgroundColor: '#f9f9f9' }}>
                                <h4 style={{ fontWeight: '600', fontSize: '1.5rem', marginBottom: '1rem', color: '#333' }}>
                                  No Shirt Measurements Saved
                                </h4>
                                <p style={{ maxWidth: '100%', wordWrap: 'break-word', whiteSpace: 'normal', lineHeight: '1.6', color: '#777' }}>
                                  To ensure the perfect replica of your favorite shirt, please add shirt measurements.
                                </p>
                              </div>
                            ) : (
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>Collar</th>
                                    <th>Sleeve</th>
                                    <th>Chest</th>
                                    <th>Midsection</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {shirtMeasurements.map(measure => (
                                    <tr key={measure.shirtMeasurementId}>
                                      <td>{measure.collarAround || '-'}</td>
                                      <td>{measure.sleeveLength || '-'}</td>
                                      <td>{measure.chestWidth || '-'}</td>
                                      <td>{measure.midsectionWidth || '-'}</td>
                                      <td>
                                        <button
                                          onClick={() => {
                                            setSelectedShirtMeasurement(measure);
                                            setShirtForm({
                                              collarAround: measure.collarAround || '',
                                              sleeveLength: measure.sleeveLength || '',
                                              yokeWidth: measure.yokeWidth || '',
                                              chestWidth: measure.chestWidth || '',
                                              midsectionWidth: measure.midsectionWidth || '',
                                              shirtLength: measure.shirtLength || '',
                                              sleeveWidth: measure.sleeveWidth || '',
                                              cuffAround: measure.cuffAround || ''
                                            });
                                            setShowShirtPopup(true);
                                          }}
                                          className="rbt-btn btn-gradient btn-sm"
                                        >
                                          Edit
                                        </button>
                                        <button
                                          onClick={() => handleDeleteShirtMeasurement(measure.shirtMeasurementId)}
                                          className="rbt-btn btn-danger btn-gradient btn-sm ms--10"
                                        >
                                          Delete
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Fit Advice */}
                      <div className="tab-pane fade" id="fitadvice" role="tabpanel">
                        <div className="rbt-fit-request-wrap">
                          <h2 className="rbt-fit-title">Create New Fit Advice Request</h2>
                          {[{
                            title: "SELECT YOUR GARMENT",
                            subtext: "Select the custom garment you’d like fit advice on.",
                            note: "You haven’t received any custom garments yet.",
                            active: true
                          }, {
                            title: "UPLOAD FIT PHOTOS",
                          }, {
                            title: "SPECIFY FIT ISSUES",
                          }].map((step, index) => (
                            <div className={`rbt-fit-step ${step.active ? 'active' : 'disabled'}`} key={index}>
                              <h4 className="rbt-fit-step-title">{step.title}</h4>
                              {step.subtext && <p className="rbt-fit-step-subtext">{step.subtext}</p>}
                              {step.note && <p className="rbt-fit-note">{step.note}</p>}
                              {step.active && <button className="rbt-fit-next">NEXT STEP →</button>}
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Returns */}
                      <div className="tab-pane fade" id="returns" role="tabpanel">
                        <div className="rbt-returns-wrap">
                          <div className="rbt-returns-header">
                            <h2 className="rbt-returns-title">Returns</h2>
                            <button className="rbt-returns-btn">+ NEW RETURN</button>
                          </div>
                          <p className="rbt-returns-text">
                            We stand behind our products... <a href="#" className="rbt-link">return policy</a>.
                          </p>
                          <p className="rbt-returns-text">If you’d like to return a product...</p>
                          <div className="rbt-returns-box">
                            <p className="rbt-returns-empty">You haven’t requested any returns yet.<br /><a href="#" className="rbt-link">Create a New Return</a></p>
                          </div>
                          <p className="rbt-returns-note">
                            Items are eligible for return up to 60 days from purchase.<br />
                            Questions? <a href="#" className="rbt-link">Contact us</a>.
                          </p>
                        </div>
                      </div>

                      {/* Address */}
                      <div className="tab-pane fade" id="address-edit" role="tabpanel">
                        <div className="rbt-my-account-inner">
                          <h3>Billing Address</h3>
                          <div className="rbt-my-account-inner">
                            {!isEditingAddress ? (
                              <address>
                                {user?.address && <p>{user.address}</p>}
                                <p>
                                  {user?.city}, {user?.state}{user?.city && user?.postalCode ? ', ' : ''}{user?.postalCode}
                                </p>
                                <p>{user?.country}</p>
                                <p>Mobile: {user?.phoneNumber}</p>
                              </address>
                            ) : (
                              <form onSubmit={(e) => { e.preventDefault(); handleBillingSave(); setIsEditingAddress(false); }}>
                                <div className="row g-4">
                                  <div className="col-lg-6 col-12">
                                    <input
                                      type="text"
                                      name="address"
                                      placeholder="Address"
                                      value={billingInfo.address}
                                      onChange={handleBillingChange}
                                    />
                                  </div>
                                  <div className="col-lg-6 col-12">
                                    <input
                                      type="text"
                                      name="city"
                                      placeholder="City"
                                      value={billingInfo.city}
                                      onChange={handleBillingChange}
                                    />
                                  </div>
                                  <div className="col-lg-6 col-12">
                                    <input
                                      type="text"
                                      name="state"
                                      placeholder="State"
                                      value={billingInfo.state}
                                      onChange={handleBillingChange}
                                    />
                                  </div>
                                  <div className="col-lg-6 col-12">
                                    <input
                                      type="text"
                                      name="postalCode"
                                      placeholder="Postal Code"
                                      value={billingInfo.postalCode}
                                      onChange={handleBillingChange}
                                    />
                                  </div>
                                  <div className="col-lg-6 col-12">
                                    <select
                                      name="country"
                                      value={billingInfo.country}
                                      onChange={handleBillingChange}
                                      className="form-control"
                                      style={{
                                        height: '50px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        padding: '10px 15px',
                                        fontSize: '16px',
                                        backgroundColor: '#fff',
                                        color: '#333',
                                        appearance: 'none',
                                        WebkitAppearance: 'none',
                                        MozAppearance: 'none',
                                      }}
                                    >
                                      <option value="">Select Country</option>
                                      {countries.map((c, idx) => (
                                        <option key={idx} value={c}>{c}</option>
                                      ))}
                                    </select>
                                  </div>

                                  <div className="col-lg-6 col-12">
                                    <input
                                      type="text"
                                      name="phoneNumber"
                                      placeholder="Phone Number"
                                      value={billingInfo.phoneNumber}
                                      onChange={handleBillingChange}
                                    />
                                  </div>
                                  <div className="col-12">
                                    <button type="submit" className="rbt-btn btn-gradient icon-hover">
                                      <span className="btn-text">Save</span>
                                      <span className="btn-icon"><i className="feather-check"></i></span>
                                    </button>
                                  </div>
                                </div>
                              </form>
                            )}
                            <br />
                            <div className="rbt-link-hover">
                              {!isEditingAddress ? (
                                <a href="#" className="d-inline-block" onClick={(e) => {
                                  e.preventDefault();
                                  setIsEditingAddress(true);
                                }}>
                                  <i className="fa fa-edit mr--5"></i>Edit
                                </a>
                              ) : (
                                <a href="#" className="d-inline-block" onClick={(e) => {
                                  e.preventDefault();
                                  setIsEditingAddress(false);
                                }}>
                                  <i className="fa fa-times mr--5"></i>Cancel
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Account Info */}
                      <div className="tab-pane fade" id="account-info" role="tabpanel">
                        <div className="rbt-my-account-inner">
                          <h3>Account Details</h3>
                          <form onSubmit={handleUpdate}>
                            <div className="row g-5">
                              <div className="col-lg-6 col-12">
                                <input name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First Name" type="text" />
                              </div>
                              <div className="col-lg-6 col-12">
                                <input name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name" type="text" />
                              </div>
                              <div className="col-12">
                                <input name="username" value={formData.username} onChange={handleChange} placeholder="Display Name" type="text" />
                              </div>
                              <div className="col-12">
                                <input name="email" value={formData.email} onChange={handleChange} placeholder="Email Address" type="email" />
                              </div>
                              <div className="col-12"><h4>Password change</h4></div>
                              <div className="col-12">
                                <input name="currentPassword" value={formData.currentPassword} onChange={handleChange} placeholder="Current Password" type="password" required />
                              </div>
                              <div className="col-lg-6 col-12">
                                <input name="newPassword" value={formData.newPassword} onChange={handleChange} placeholder="New Password (optional)" type="password" />
                              </div>
                              <div className="col-lg-6 col-12">
                                <input name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="Confirm New Password" type="password" />
                              </div>
                              <div className="col-12">
                                <button type="submit" className="rbt-btn btn-gradient icon-hover">
                                  <span className="btn-text">Save Changes</span>
                                  <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>

                    </div>
                  </div>
                  {/* End Tab Content */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />

        {/* Body Measurement Popup */}
        {showBodyPopup && (
          <div className="measure-popup-overlay show-measure-popup">
            <div className="measure-popup-content">
              <span className="measure-close-btn" onClick={() => setShowBodyPopup(false)}>&times;</span>

              <div className="measure-popup-grid">
                <div className="measure-popup-left">
                  <h3>MEASURE YOUR BODY</h3>
                  <form onSubmit={(e) => e.preventDefault()}>
                    {[
                      { key: 'neckAround', label: 'Neck Around' },
                      { key: 'sleeveLength', label: 'Sleeve Length' },
                      { key: 'shoulderWidth', label: 'Shoulder Width' },
                      { key: 'chestAround', label: 'Chest Around' },
                      { key: 'waistAround', label: 'Waist Around' },
                      { key: 'shirtLength', label: 'Shirt Length' },
                      { key: 'bicepAround', label: 'Bicep Around' },
                      { key: 'wristAround', label: 'Wrist Around' },
                    ].map(item => (
                      <React.Fragment key={item.key}>
                        <label>{item.label}</label>
                        <div className="measure-input-group">
                          <input
                            type="text"
                            value={bodyForm[item.key]}
                            onChange={e => handleBodyInputChange(item.key, e.target.value)}
                            onFocus={() => {
                              setCurrentVideoKey(item.key);
                              setCurrentVideoType('Body');
                            }}
                          />
                          <span>in</span>
                        </div>
                      </React.Fragment>
                    ))}

                    <label>Fit</label>
                    <div
                      className={`measure-custom-select ${fitDropdownOpen ? "active" : ""}`}
                      onClick={() => setFitDropdownOpen(!fitDropdownOpen)}
                    >
                      <div className="measure-selected">{bodyForm.fit}</div>
                      {fitDropdownOpen && (
                        <div className="measure-options">
                          {['Slim', 'Regular', 'Loose'].map(opt => (
                            <div
                              key={opt}
                              className="measure-option"
                              onClick={() => handleFitSelect(opt)}
                            >
                              {opt}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <button
                      type="button"
                      className="measure-done-btn"
                      onClick={handleSaveBodyMeasurement}
                    >
                      DONE, CREATE SIZE.
                    </button>
                  </form>
                </div>

                <div className="measure-popup-right">
                  <h2>{currentVideoKey?.replace(/([A-Z])/g, ' $1') || 'Measurement Guide'}</h2>
                  <p>Watch this video to measure accurately.</p>
                  <iframe
                    width="100%"
                    height="50%"
                    src={measurementVideos[currentVideoType]?.[currentVideoKey] || ''}
                    allowFullScreen
                  ></iframe>
                </div>

              </div>
            </div>
          </div>
        )}

        {/* Shirt Measurement Popup */}
        {showShirtPopup && (
          <div className="measureShirt-popup-overlay" id="measureShirtPopupOverlay">
            <div className="measureShirt-popup-content">
              <span className="measureShirt-close-btn" onClick={() => setShowShirtPopup(false)}>&times;</span>

              <div className="measureShirt-popup-grid">
                <div className="measureShirt-popup-left">
                  <h3>MEASURE YOUR Shirt</h3>
                  <form>
                    {[
                      { key: 'collarAround', label: 'Collar Around' },
                      { key: 'sleeveLength', label: 'Sleeve Length' },
                      { key: 'yokeWidth', label: 'Yoke Width' },
                      { key: 'chestWidth', label: 'Chest Width' },
                      { key: 'midsectionWidth', label: 'Midsection Width' },
                      { key: 'shirtLength', label: 'Shirt Length' },
                      { key: 'sleeveWidth', label: 'Sleeve Width' },
                      { key: 'cuffAround', label: 'Cuff Around' },
                    ].map(item => (
                      <React.Fragment key={item.key}>
                        <label>{item.label}</label>
                        <div className="measureShirt-input-group">
                          <input
                            type="text"
                            value={shirtForm[item.key]}
                            onChange={(e) => handleShirtInputChange(item.key, e.target.value)}
                            onFocus={() => {
                              setCurrentVideoKey(item.key);
                              setCurrentVideoType('Shirt');
                            }}
                          />
                          <span>in</span>
                        </div>
                      </React.Fragment>
                    ))}

                    <button
                      type="button"
                      className="measureShirt-done-btn"
                      onClick={handleSaveShirtMeasurement}
                    >
                      DONE, CREATE SIZE.
                    </button>
                  </form>
                </div>

                <div className="measureShirt-popup-right">
                  <h2>{currentVideoKey?.replace(/([A-Z])/g, ' $1') || 'Measurement Guide'}</h2>
                  <p>Watch this video to measure accurately.</p>
                  <iframe
                    width="100%"
                    height="50%"
                    src={measurementVideos[currentVideoType]?.[currentVideoKey] || ''}
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        )}

      </main>
      <div className="rbt-progress-parent">
        <svg className="rbt-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </>
  );
};

export default ClientDetails;
